import {constants} from '../../../redux/constants'
import {IFeedbackState} from './reducers'

export const feedbackActions = {
  setState: (state: IFeedbackState) => ({
    type: constants.SET_FEEDBACK_STATE,
    state,
  }),
}
